import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Formik } from 'formik'

import { Box, Card, Grid, H6 } from '@dhl-ui/components'
import { PostUser, useNewUser } from '@dhl/keycloak-user-api'
import { BackButton } from '~/temp-ds-component/BackButton'

import { useNotificationMessage } from '~/common'

import { AdminUserForm, CancelDialog, createValidationSchema, type FormValues } from '~/modules/adminusers/components'
import { links } from '~/AppRoutes'

export const AddAdminPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [cancelDialogOpen, setCancelDialogOpen] = useState<boolean>(false)
  const validationSchema = createValidationSchema(t)
  const { showError, showSuccess } = useNotificationMessage()

  const { mutateAsync: postUser } = useNewUser()

  const initialValues: FormValues = {
    firstName: '',
    lastName: '',
    email: '',
  }

  const onSubmit = async (formFields: FormValues) => {
    const user: PostUser = {
      username: formFields.email,
      firstName: formFields.firstName,
      lastName: formFields.lastName,
    }
    await postUser(
      { data: user },
      {
        onSuccess: (data) => {
          showSuccess(t('admin.adminUsersPage.userForm.createUserMessage'))
          navigate(links.userOverviewDetailsLink(data.id))
        },
        onError: () => {
          showError(t('admin.adminUsersPage.userForm.userExistsMessage'))
        },
      }
    )
  }

  const onBack = (dirty: boolean) => {
    dirty ? setCancelDialogOpen(true) : navigate(links.usersLink())
  }

  return (
    <>
      <Formik initialValues={initialValues} onSubmit={onSubmit} validateOnMount validationSchema={validationSchema}>
        {({ dirty }) => (
          <>
            <Grid>
              <Box marginBottom={2}>
                <BackButton onClick={() => onBack(dirty)}>
                  {t('admin.adminUsersPage.userForm.backButtonTitle')}
                </BackButton>
              </Box>
            </Grid>
            <Card>
              <Card.Header title={t('admin.adminUsersPage.userForm.titleText')} />
              <Card.Content>
                <H6>{t('admin.adminUsersPage.userForm.addTitleText')}</H6>
                <AdminUserForm onCancel={() => onBack(dirty)} />
              </Card.Content>
            </Card>
          </>
        )}
      </Formik>
      <CancelDialog open={cancelDialogOpen} onCancel={() => setCancelDialogOpen(false)} />
    </>
  )
}
